<template>
  <div class="container-card-input">
    <div class="add-item">
      <el-button
        round
        @click="handleAdd(num)"
      ><i class="el-icon-plus"/>
        Agregar cirugía
      </el-button>
    </div>
    <div class='cards' v-if="cirugias.length >= 1">
      <div class="card-general" v-for="(cirugias, idx) in cirugias" :key="idx">
        <div class="card-title" style="background:#A57DD3;border-radius:8px;">
          <strong style="color: #fff;;">Cirugía {{ cirugias.id }}</strong>
        </div>
        <div class="item-card">
          <label>Lado</label>
          <el-select v-model="cirugias.eye" placeholder="Select" size="medium">
            <el-option
              v-for="item in ladoOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <label>Costo</label>
          <el-select v-model="cirugias.cost" @change="isWithCost(idx)">
            <el-option
              v-for="item in optionsCosto"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div v-if="cirugias.cost === 'con costo'">
            <div>
              <label>Precio</label>
              <el-input v-model="cirugias.price" size="medium"/>
            </div>
            <div style="display: flex; flex-direction: column;">
              <label>Moneda</label>
              <el-select
                v-model="cirugias.currency"
                placeholder="Select"
                size="medium"
              >
                <el-option
                  v-for="item in currency"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <el-divider />
          <label>Especialidad</label>
          <el-select
            v-model="cirugias.specialty"
            placeholder="Seleccionar"
            size="medium"
            @change="() => {
              cirugias.type = null;
              filterProcedures(idx);
            }"
          >
            <el-option
              v-for="item in specialtyOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <div style="width: 100%;margin-top:10px;" v-if="cirugias.specialty">
            <label>Procedimiento</label> <br>
            <label
              style="color: rgb(148 144 144);"
            >En caso de no encontrar el procedimiento
              puede escribirlo y seleccionarlo para darlo de alta.</label>
            <el-select
              style="width: 100%;"
              v-model="cirugias.type"
              placeholder="Seleccionar"
              size="medium"
              multiple
              allow-create
              filterable
              @change="verificarProcedimiento(idx)"
            >
              <el-option
                v-for="item in procedureOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="success"
              size="mini"
              @click="agregarEspecialidad(idx)"
              style="margin-top:10px; width: 100%;"
            >
              <i class="el-icon-plus"/>
              Agregar
            </el-button>
            <el-divider />
          </div>
          <el-divider />
          <el-table
            :data="cirugias.complements"
            style="width: 100%"
            stripe
          >
          <!-- <el-table-column label="ID" width="50">
            <template slot-scope="scope">
              <span>{{ scope.row.id }}</span>
            </template>
          </el-table-column> -->
            <el-table-column
              prop="specialty"
              label="Especialidad"
            />
            <el-table-column
              prop="type"
              label="Procedimiento"
            />
            <el-table-column width="60">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteComplement(idx, scope.$index)"
                >
                  <i class="el-icon-delete"/>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="buttons-options">
          <el-button
            v-if="cirugias.id"
            type="primary"
            icon="el-icon-refresh-right"
            @click="cirugiasUpdate(idx)">Actualizar
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="cirugiasDelete(idx)">Eliminar
          </el-button>
          <el-button
            v-if="!cirugias.id"
            type="success"
            icon="el-icon-plus"
            @click="cirugiasAdd(idx)"
          >
            Agregar
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    costo: {
      type: String,
      default: 'sin costo',
    },
    evaluationId: {
      type: String,
      default: null,
    },
    idAppointment: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      cirugias: [],
      optionsCosto: [
        {
          label: 'Con Costo',
          value: 'con costo',
        },
        {
          label: 'Sin Costo',
          value: 'sin costo',
        },
      ],
      num: 0,
      antNumber: 0,
      ladoOptions: [
        {
          value: 'RIGHT',
          label: 'Ojo derecho',
        },
        {
          value: 'LEFT',
          label: 'Ojo izquierdo',
        },
        {
          value: 'BOTH',
          label: 'Ambos ojos',
        },
      ],
      procedures: [],
      specialtyOptions: [
        {
          value: 1,
          label: 'Córnea',
        },
        {
          value: 2,
          label: 'Glaucoma',
        },
        {
          value: 3,
          label: 'Orbita',
        },
        {
          value: 4,
          label: 'Retina',
        },
        {
          value: 5,
          label: 'Oftalmopediatría',
        },
        {
          value: 6,
          label: 'Refractiva',
        },
        {
          value: 7,
          label: 'Segmento Anterior',
        },
      ],
      procedureOptions: [],
      type: [
        {
          Córnea: [
            {
              value: 'TRASPLANTE DE CÓRNEA',
              label: 'TRASPLANTE DE CÓRNEA',
            },
            {
              value: 'CROSSLINKING',
              label: 'CROSSLINKING',
            },
            {
              value: 'ICL',
              label: 'ICL',
            },
            {
              value: 'ICL TÓRICO',
              label: 'ICL TÓRICO',
            },
            {
              value: 'CIERRE DE HERIDA CORNEAL',
              label: 'CIERRE DE HERIDA CORNEAL',
            },
            {
              value: 'COLGAJO CONJUNTIVAL',
              label: 'COLGAJO CONJUNTIVAL',
            },
            {
              value: 'IMPLANTE DE LENTE',
              label: 'IMPLANTE DE LENTE',
            },
            {
              value: 'LENTE FIJADO A ESCLERA',
              label: 'LENTE FIJADO A ESCLERA',
            },
          ],
          Oftalmopediatría: [
            {
              value: 'ESTRABISMO',
              label: 'ESTRABISMO',
            },
            {
              value: 'CATARATA PEDIATRICA',
              label: 'CATARATA PEDIATRICA',
            },
            {
              value: 'CHALAZION',
              label: 'CHALAZION',
            },
            {
              value: 'EXPLORACIÓN BAJO ANESTESIA',
              label: 'EXPLORACIÓN BAJO ANESTESIA',
            },
          ],
          Glaucoma: [
            {
              value: 'TRABE',
              label: 'TRABE',
            },
            {
              value: 'FACO TRABE',
              label: 'FACO TRABE',
            },
            {
              value: 'VALVULA',
              label: 'VALVULA',
            },
            {
              value: 'FACO VÁLVULA',
              label: 'FACO VÁLVULA',
            },
            {
              value: 'DIODO',
              label: 'DIODO',
            },
            {
              value: 'FACO DIODO',
              label: 'FACO DIODO',
            },
            {
              value: 'REACOMODO DE VÁLVULA',
              label: 'REACOMODO DE VÁLVULA',
            },
          ],
          Retina: [
            {
              value: 'VITRECTOMIA',
              label: 'VITRECTOMIA',
            },
            {
              value: 'FACOVITRECTOMIA',
              label: 'FACOVITRECTOMIA',
            },
            {
              value: 'FACOVITRECTOMIA + CERCLAJE',
              label: 'FACOVITRECTOMIA + CERCLAJE',
            },
            {
              value: 'VITRECTOMIA + CERCLAJE',
              label: 'VITRECTOMIA + CERCLAJE',
            },
            {
              value: 'RETIRO DE SILICÓN',
              label: 'RETIRO DE SILICÓN',
            },
            {
              value: 'FACO DIODO',
              label: 'FACO DIODO',
            },
            {
              value: 'FACO + RETIRO DE SILICÓN',
              label: 'FACO + RETIRO DE SILICÓN',
            },
          ],
          SegmentoAnterior: [
            {
              value: 'CATARATA',
              label: 'CATARATA',
            },
            {
              value: 'PTERIGIÓN',
              label: 'PTERIGIÓN',
            },
            {
              value: 'PTERIGIÓN + MEMBRANA ',
              label: 'PTERIGIÓN + MEMBRANA ',
            },
            {
              value: 'IMPLANTE DE LÍO',
              label: 'IMPLANTE DE LÍO',
            },
          ],
        },
      ],
      currency: [
        {
          label: 'USD',
          value: 'USD',
        },
        {
          label: 'MXN',
          value: 'MXN',
        },
      ],
    };
  },
  methods: {
    verificarProcedimiento(idx) {
      // comprobar siel ultimo procedimiento es de la especialidad seleccionada
      const { type } = this.cirugias[idx];
      const { specialty } = this.cirugias[idx];
      const lastProcedure = type[type.length - 1];

      const existProcedure = !!this.procedureOptions.find((item) => item.value === lastProcedure);

      if (!existProcedure && lastProcedure) {
        try {
          const request = this.axios.post('patient/surgeryProcedures', {
            specialtyId: specialty,
            name: lastProcedure,
          });
          if (request) {
            this.$notify({
              type: 'success',
              title: '¡Éxito!',
              message: 'Se ha agregado procedimiento',
            });
            this.getAllProcedures();
          }
        } catch (error) {
          this.$notify({
            type: 'error',
            title: '¡Error!',
            message: 'No se pudo agregar procedimiento',
          });
        }
      }
    },
    async agregarEspecialidad(idx) {
      let specialty = null;

      if (!this.cirugias[idx].specialty || !this.cirugias[idx].type) {
        this.$notify({
          type: 'error',
          title: '¡Error!',
          message: 'Debe seleccionar especialidad y procedimiento',
        });
        return;
      }

      if (!this.cirugias[idx]?.id) {
        // guardar cirugia
        await this.cirugiasAdd(idx);
      }

      if (this.cirugias[idx].specialty.length > 1) {
        specialty = this.cirugias[idx].specialty;
      } else {
        specialty = this.specialtyOptions.find(
          (item) => item.value === this.cirugias[idx].specialty,
        )?.label;
      }

      try {
        this.cirugias[idx].complements.push({
          specialty,
          type: this.cirugias[idx].type.toString(),
        });

        const request = await this.axios.post(`patient/surgery/complement/${this.cirugias[idx].id}`, {
          specialty,
          procedure: this.cirugias[idx].type.toString(),
        });

        if (request) {
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha agregado complemento',
          });
          await this.getCirugias();
        }
      } catch (error) {
        // // console.log(error);
      } finally {
        this.cirugias[idx].specialty = null;
        this.cirugias[idx].type = null;
        setTimeout(() => this.$loading().close(), 1500);
      }
    },
    async deleteComplement(idx, index) {
      try {
        const complementId = this.cirugias[idx].complements[index].id;
        const request = await this.axios.delete(`patient/surgery/complement/${complementId}`);
        if (request) {
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha eliminado complemento',
          });
        }
        this.cirugias[idx].complements.splice(index, 1);
      } catch (error) {
        // // console.log(error);
      }
    },
    isWithCost(idx) {
      if (this.cirugias[idx].cost === 'sin costo') {
        this.cirugias[idx].price = 0;
        this.cirugias[idx].currency = null;
      }
    },
    handleAdd(num) {
      if (num < this.antNumber) {
        this.cirugias.pop();
      } else {
        this.cirugias.push({
          number: num + 1,
          eye: null,
          specialty: null,
          type: null,
          price: 0,
        });
      }
      this.antNumber = num;
      this.num += 1;
    },
    async cirugiasUpdate(idx) {
      try {
        const carId = this.cirugias[idx].id;
        const cirugia = {
          eye: this.cirugias[idx]?.eye,
          // specialty: this.cirugias[idx]?.specialty,
          // type: this.cirugias[idx]?.type.toString(),
          price: this.cirugias[idx]?.price || 0,
          currency: this.cirugias[idx]?.currency,
        };
        const request = await this.axios.put(`patient/surgery/${this.evaluationId}/${carId}`, cirugia);
        if (request) {
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha actualizado cirugía',
          });
        }
      } catch (error) {
        // // console.log(error);
      }
    },
    async getCirugias() {
      try {
        this.loading = true;
        this.cirugias = [];
        const response = await this.axios.get(`patient/surgery/${this.evaluationId}`);
        const { data } = response;
        if (Array.isArray(data)) {
          data.forEach((cirugia) => {
            const type = cirugia.type.includes(',') ? cirugia.type.split(',') : [cirugia.type];
            this.cirugias.push({
              id: cirugia.id,
              eye: cirugia.eye,
              specialty: cirugia.specialty === ' ' ? null : cirugia.specialty,
              // type: type === ' ' ? null : type,
              type: type[0] === ' ' ? null : type,
              cost: cirugia.price > 0 ? 'con costo' : 'sin costo',
              price: cirugia.price,
              currency: cirugia.currency,
              complements: cirugia.surgeryComplement.map((complement) => ({
                id: complement.id,
                specialty: complement.specialty,
                type: complement.procedure.split(',').join(', '),
              })),
            });
          });
        }
        this.loading = false;
      } catch (error) {
        this.$errorNotify(error);
        this.loading = false;
      }
    },
    cirugiasDelete(idx) {
      try {
        if (this.cirugias[idx].id > 0) {
          this.loading = true;
          const carId = this.cirugias[idx].id;
          const request = this.axios.delete(`patient/surgery/${carId}`);
          if (request) {
            this.$notify({
              type: 'success',
              title: '¡Éxito!',
              message: 'Se ha eliminado cirugía',
            });
          }
          this.loading = false;
        }
        this.cirugias.splice(idx, 1);
      } catch (error) {
        this.loading = false;
        // console.log('err', error);
      }
    },
    async cirugiasAdd(idx) {
      try {
        let specialty = null;
        const data = this.cirugias[idx];

        if (data.specialty.length > 1) {
          specialty = data.specialty;
        } else {
          specialty = this.specialtyOptions.find(
            (item) => item.value === data.specialty,
          )?.label;
        }

        const cirugia = {
          eye: data.eye,
          specialty,
          type: data.type.toString(),
          price: data.price || 0,
          currency: data.currency,
        };
        const response = await this.axios.post(`patient/surgery/create/${this.evaluationId}`, cirugia);

        if (response.data) {
          this.$notify({
            type: 'success',
            message: 'Cirugía agregada con éxito',
          });
          await this.getCirugias();
        } else {
          this.$notify({
            type: 'danger',
            message: 'Error al guardar',
          });
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.$loading().close();
      }
    },
    async getAllProcedures() {
      try {
        const response = await this.axios.get('patient/surgeryProcedures');
        this.procedures = response.data;
      } catch (error) {
        // console.log(error);
      }
    },
    filterProcedures(idx) {
      const { specialty } = this.cirugias[idx];

      const options = this.procedures.filter((item) => item.specialtyId === specialty);

      this.procedureOptions = options.map((item) => ({
        label: item.name,
        value: item.name,
      }));
    },
  },
  async created() {
    await this.getCirugias();
    await this.getAllProcedures();
  },
};
</script>

<style lang="scss">
.add-item {
  margin-bottom: 20px;
}
.cards {
  width: 50%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
}
.card-general {
  min-width: 500px;
  height: auto;
  background-color: rgb(255, 255, 255);
  border: solid 1px #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  strong {
    margin-right: 10px;
    font-size: 12px;
    color: rgb(133, 133, 133);
  }
  .card-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px 10px;
    border-bottom: 1px solid #dde0e7;
    box-sizing: border-box;
    color: white;
    strong {
      font-size: 16px;
      color: rgb(58, 58, 58);
    }
  }
}
.card-general:hover {
  border: solid 1px rgba(77, 129, 241, 0.507);;
  transition: border-color .3s cubic-bezier(.645,.045,.355,1);
  box-shadow: 0 2px 12px 0 rgba(126, 77, 241, 0.11);
  .card-title {
    border-bottom: solid 1px rgba(77, 88, 241, 0.507);;
    transition: border-color .3s cubic-bezier(.645,.045,.355,1);
  }
}
.item-card {
  padding: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  label {
    font-size: 12px;
    color: rgb(58, 58, 58);
    margin: 8px 0px;
  }
}
.buttons-options {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: right;
}
</style>
